var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-overlay',{staticClass:"loading-indicator",attrs:{"value":_vm.loading,"z-index":"999"}},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":"64"}}),(_vm.message)?_c('div',{staticClass:"text-h5"},[_vm._v(_vm._s(_vm.message))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }